import { ff_merge_objects } from './objects';

/**
 * Fait une requête AJAX asynchrone avec $.ajax() avec des paramètres de base définis.
 *
 * @param {object} params Paramètres de la requête AJAX. Https://api.jquery.com/jquery.ajax/.
 * @returns {object} Objet de la requête. Https://api.jquery.com/jQuery.ajax/#jqXHR.
 */
function ff_ajax(params) {

  // Paramètres par défaut
  const default_params = {
    url     : `${ff_root_url}wp-admin/admin-ajax.php`,
    type    : 'POST',
    dataType: 'html',
    error   : function (request, status, error) {
      console.error('AJAX ERROR');
      if (error) {
        console.error('Error:', error);
      }
      console.error('Request status code:', request.status, `https://developer.mozilla.org/fr/docs/Web/HTTP/Status/${request.status}`);
      console.error('Request response:', request.responseText);
    }
  };

  const default_data = {
    is_front_end: !jQuery('body').hasClass('wp-admin')
  };

  // Si param.data est un FormData
  if (typeof params.data.append === 'function') {
    default_params.processData = false;
    default_params.contentType = false;
  }

  // Fusionner les paramètres par défaut et les paramètres de la requête ajax
  // params = {...default_params,...params};
  params = ff_merge_objects(default_params, params);

  // Si param.data est un FormData
  if (typeof params.data.append === 'function') {

    // Ajouter les valeurs par défaut au FormData
    jQuery.each(default_data, (key, value) => {
      // Si toute sauf IE, on remplace seulement les paramètres s'ils ne sont pas déjà définis
      if (typeof params.data.get == 'function') {
        if (params.data.get(key) === null) { // Has ne fonctionne pas sur IOS
          params.data.append(key, value);
        }
      }
      // Si IE, on ajoute toujours les paramètres par défaut (pas idéale)
      else {
        params.data.append(key, value);
      }
    });

    /*
    // Debug values
    console.log('===========================');
    params.data.forEach(function(value,key){
      console.log(key + ' : ' + value);
    });*/

    // Si param.data n'est pas un FormData
  }
  else {

    // Si mutliples json (via serializeArray), on le tranforme en un json simple
    if (typeof params.data.entries === 'function') {
      const new_json = {};
      jQuery.each(params.data, (key, data) => {
        new_json[data.name] = data.value;
      });
      params.data = new_json;
    }

    // Ajouter les valeurs par défaut
    jQuery.each(default_data, (key, value) => {
      if (typeof params.data[key] === 'undefined') {
        params.data[key] = value;
      }
    });

  }

  return jQuery.ajax(params);

}


// Exportation
export { ff_ajax }; // eslint-disable-line import/prefer-default-export
